module.exports = __webpack_public_path__ + "img/crying-face.d3cbf7a0.svg";